import { defineComponent } from "vue";

export default defineComponent({
    props: ['hidedetail', 'dataChart'],
    data() {
        return {
            viewType: "chart"
        }
    }
})